'use strict';


var nodeMap = require('../node.map.js');

/* eslint no-useless-call: 0 */
/* eslint no-path-concat: 0 */
module.exports = function ( value, callback ) {
    var self      = this,
        $node     = nodeMap.data[this.id],
        $layout   = document.createElement('div'),
        $icon     = document.createElement('div'),
        $checkbox = document.createElement('div'),
        $text     = document.createElement('div'),
        state     = !!value;

    if ( self.cached !== null ) {
        state = self.cached;
    }

    console.log('toggle render initial state: ' + state);

    self.events['saved'] = [
        function () {
            console.log('saved');
            state = self.cached;
            self.cached = null;
        }
    ];

    while ( $node.firstChild ) {
        $node.removeChild($node.firstChild);
    }

    console.log('toggle render ' + state);

    $text.innerText = this.name;

    $icon.className = 'theme-icon ' + this.icon;
    $text.className = 'wrappedText';
    $checkbox.className = 'theme-icon theme-icon-checkbox' + (state ? '-active' : '');

    $layout.className = 'mag-component-layout';

    $layout.appendChild($icon);
    $layout.appendChild($text);
    $layout.appendChild($checkbox);

    // $node here
    $node.appendChild($layout);

    // $node here
    $node.onclick = function ( event ) {
        // very bad hack cause in main.panel 'click:item' - is bad handler
        // task #20082
        // TODO: remove this check after removing wrong event
        if ( event !== true  ) {
            return;
        }

        console.log(event, 'onclick event');
        if ( self.saveImmediate ) {
            if ( typeof self.prepareForSave === 'function' ) {
                console.log('state: ' + state);
                self.prepareForSave.call(self, !state, function ( error, afterSave ) {
                    if ( error ) {
                        console.log(error);
                    } else {
                        self.saver.call(self, function ( error, done ) {
                            if ( error ) {
                                console.log(error);
                            } else {
                                state = !state;
                                self.cached = null;
                                console.log('state: ' + state);
                                $checkbox.className = 'theme-icon theme-icon-checkbox' + (state ? '-active' : '');

                                if ( typeof afterSave === 'function' ) {
                                    afterSave.call(self);
                                }
                            }

                            if ( typeof done === 'function' ) {
                                done.call(self, error);
                            }
                        });
                    }
                });
            } else {
                throw Error(__filename + ' saveImmediate: true for toggle render must use prepareForSave method');
                // self.saver.call(self, function ( error, callback ) {
                //     if ( !error ) {
                //         state = self.cached;
                //         self.cached = null;
                //         $checkbox.className = 'theme-icon theme-icon-checkbox' + (state ? '-active' : '');
                //     }

                //     if ( typeof callback === 'function' ) {
                //         callback.call(self, error);
                //     }
                // });
            }
        } else {
            if ( self.cached === null ) {
                self.cached = state;
            }
            self.cached = !self.cached;
            $checkbox.className = 'theme-icon theme-icon-checkbox' + (self.cached ? '-active' : '');
            nodeMap.data[self.id].listInstance.$nodeChange(self.cached !== state, self, self.cached);
        }
    };

    callback();
};
